import styled from 'styled-components'
import genLinkParams from '@/lib/generateLinkParams'
import { useTranslation } from 'react-i18next'

const Nav = styled.nav`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
`

function ServiceLink({ service }) {
  const parentSlug = service.direction?.slug
  if (!service.slug || !parentSlug) {
    return null
  }

  const [, as] = genLinkParams({
    type: 'service',
    parentSlug,
    slug: service.slug,
  })

  if (!as) {
    return null
  }

  return (
    <li>
      <a href={as}>{service.title}</a>
    </li>
  )
}

function DirectionGroup({ group, onlyDirections }) {
  const [, as] = genLinkParams({ type: 'direction', slug: group.slug })

  if (!as) {
    return null
  }

  const hasNested = group.services?.length > 0 || group.children.length > 0

  return (
    <li>
      <a href={as}>{group.title}</a>
      {hasNested && (
        <ul>
          {!onlyDirections && group.services.map((service) => (
            <ServiceLink key={service.id || `${group.slug}/${service.slug}`} service={service} />
          ))}
          {group.children.map((child) => (
            <DirectionGroup key={child.slug} group={child} />
          ))}
        </ul>
      )}
    </li>
  )
}

export default function SeoServiceLinks({ groups = [], onlyDirections = false }) {
  const { t } = useTranslation('global')

  if (!groups.length) {
    return null
  }

  return (
    <Nav aria-label={t('menu.servicesTitle')}>
      <ul>
        {groups.map((group) => (
          <DirectionGroup key={group.slug} group={group} onlyDirections={onlyDirections} />
        ))}
      </ul>
    </Nav>
  )
}
